import "./App.css";
import React from "react";
import Home from "./pages/Home";
import Auth from "./pages/Auth";
import Notif from "./pages/Notif";
import Alerta from "./components/Alerta";
import Loadergf from "./components/Loadergf";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";

import Reporte from "./views/Reporte";
import Usuarios from "./views/Usuarios";
import Vistas from "./views/Vistas";

import { amb } from "./requests/utils";

export const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) => {
      const isLogin = localStorage.getItem(`${amb}_login`);
      if (isLogin === "1") {
        return <Component {...props} />;
      }
      return <Redirect to="/auth/login" />;
    }}
  />
);

function App() {
  return (
    <div className="App">
      <Alerta />
      <Loadergf />
      <BrowserRouter>
        <Switch>
          <Route path="/auth" render={(props) => <Auth {...props} />} />
          <Route path="/user" render={(props) => <Home {...props} />} />
          <Route path="/notif" render={(props) => <Notif {...props} />} />
          <PrivateRoute component={Usuarios} exact path="/usuarios" />
          <PrivateRoute component={Vistas} exact path="/vistas" />
          <PrivateRoute component={Reporte} exact path="/reporte/:id/:desc" />
          <Redirect from="/" to="/auth/login" />
        </Switch>
      </BrowserRouter>
    </div>
  );
}

export default App;
